export default "__VITE_ASSET__0ffb1558__"